var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-new',
  created () {
    this.search()
    this.getAreas()
    this.map_zoom = 11
  },
  data () {
    return {
      canValidate: true,
      canSearchLocation: false,
      keepAddress: null,
      savingFlag: false,
      shop: {
        shop_name: null,
        shop_name_furigana: null,
        shop_post_no: null,
        shop_address: null,
        shop_tel: null,
        shop_fax: null,
        map_lat: null,
        map_lng: null,
        map_zoom: 15,
        area: null
      },
      map: null,
      mk: null,
      areaWork: null
    }
  },
  computed: {
    areas () {
      return this.$store.getters.areas
    },
    selectArea: function() {
      this.shop.area = this.areaWork
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    loading: function() {
      return this.$store.getters.apiLoading
    },
    required: function() {
      return {
        shop_post_no: utils.isBlank(this.shop.shop_post_no),
        shop_address: utils.isBlank(this.shop.shop_address),
        shop_post_no_format: !utils.isPostNo(this.shop.shop_post_no)
      }
    },
    validation: function() {
      var hiragana = /^[\u3040-\u309fー]+$/
      var tel = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      var fax = /^[0-9-]+$/
      var number = /^[0-9]+$/
      var v = {
        shop_name: !!this.shop.shop_name,
        shop_name_furigana: hiragana.test(this.shop.shop_name_furigana),
        shop_post_no: !!this.shop.shop_post_no,
        shop_address: !!this.shop.shop_address,
        shop_tel: tel.test(this.shop.shop_tel),
        shop_fax: fax.test(this.shop.shop_fax) || !this.shop.shop_fax,
        not_input: !!this.shop.shop_name &&
                   hiragana.test(this.shop.shop_name_furigana) &&
                   !!this.shop.shop_post_no &&
                   number.test(this.shop.shop_post_no) &&
                   !!this.shop.shop_address &&
                   tel.test(this.shop.shop_tel) &&
                   (fax.test(this.shop.shop_fax) || !this.shop.shop_fax)
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    notify () {
      return this.$store.getters.shopNewNotify
    },
  },
  components: {
    AppHeader
  },
  methods: {
    async getAreas () {
      await this.$store.dispatch('AREA_ALL_GET', {})
    },
    selectedArea () {
      this.shop.area = areaWork
    },
    goUserLists: function () {
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    onClickCancel: function () {
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var self = this
      self.shop.map_lat = 33.589085
      self.shop.map_lng = 130.412232
      var callback = function () {
        setTimeout(() => {
          self.initMap()
        }, 100)
      }
    },
    onBlurAddress: function () {
      if ((this.shop.shop_address !== null) && (this.shop.shop_address !== "")) {

        if (this.keepAddress !== this.shop.shop_address) {
          this.canSearchLocation = true
          this.keepAddress = this.shop.shop_address
          this.searchLocationByGeocoder()
        }
      }
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      var self = this
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        self.shop.images = self.images
        this.$store.dispatch('SHOP_CREATE', { data: self.shop, callback: self.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/shops')
    },
    onChangePostNo: function () {
      if (this.shop.shop_post_no) {
        this.shop.shop_post_no = this.shop.shop_post_no.replace(/-/g,"")
      }

      if (!!this.shop.shop_post_no && utils.regex.post_no.test(this.shop.shop_post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.shop.shop_post_no, callback: (addr) => {
            if (addr) {
              this.shop.shop_address = addr.address1 + addr.address2
              this.onChangeAddress()
              this.onBlurAddress()
            }
          }
        })
      }
    },
    onChangeAddress: function () {
      var arr = []
      if (utils.isPresent(this.shop.shop_post_no)) arr.push(this.shop.shop_post_no)
      if (utils.isPresent(this.shop.shop_address)) arr.push(this.shop.shop_address)
      if (arr.length > 0) {
        var address = arr.join(' ')
        if (window.googleMapsQuerySearch) {
          window.googleMapsQuerySearch(address)
        }
      }
    },
    initMap: function () {
      var mapDiv = document.getElementById('map')
      this.map = new google.maps.Map(mapDiv, {
        zoom: this.map_zoom,
        center: new google.maps.LatLng(this.shop.map_lat, this.shop.map_lng)
      })
      if (this.canSearchLocation === true){
        this.canSearchLocation = false
        this.mk = new google.maps.Marker({
          map: this.map,
          position: new google.maps.LatLng(this.shop.map_lat, this.shop.map_lng),
        })
        this.mk.setMap(this.map)
      }
      google.maps.event.addListener(this.map, 'click', this.setMarker)
    },
    setMarker: function (event) {
      this.shop.map_lat = event.latLng.lat()
      this.shop.map_lng = event.latLng.lng()
      this.shop.map_zoom = this.map.getZoom()
      var latlng = new google.maps.LatLng(event.latLng.lat(),event.latLng.lng())
      if(this.mk){
        this.mk.setPosition(latlng)
      }else{
        this.mk = new google.maps.Marker({
          map: this.map,
          position: latlng,
        })
        this.mk.setMap(this.map)
      }
    },
    half: function () {
      if (!utils.isBlank(this.shop.shop_name)) this.shop.shop_name = utils.emHalf(this.shop.shop_name)
      if (!utils.isBlank(this.shop.shop_name_furigana)) this.shop.shop_name_furigana = utils.emHalf(this.shop.shop_name_furigana)
      if (!utils.isBlank(this.shop.shop_address)) this.shop.shop_address = utils.emHalf(this.shop.shop_address)
    },
    searchLocationByGeocoder: function(){
      var self = this
      var geocoder = new google.maps.Geocoder()
      geocoder.geocode({'address': self.shop.shop_address}, function(results, status){
        if(status == google.maps.GeocoderStatus.OK){
          self.shop.map_lat = results[0].geometry.location.lat()
          self.shop.map_lng = results[0].geometry.location.lng()
          self.map_zoom = 15
        }
      })
      setTimeout(() => {
        self.initMap()
      }, 1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-new.js